import {useState, useContext} from 'react';
import {AxiosContext} from '../components/utils/AxiosProvider';

const usePostBin = () => {
    const [submitting, setSubmitting] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const {client: axiosClient} = useContext(AxiosContext);

    const onFormPosted = result => {
        setSubmitting(false);
        error && setError(null);
        setResult(result.data);
    };

    const onError = error => {
        setSubmitting(false);
        result && setResult(null);
        setError(error.response?.data);
    };

    const post = formData => {
        setSubmitting(true);
        return axiosClient
            .post('/api/1/user/bin', formData)
            .then(onFormPosted)
            .catch(onError);
    };

    const sendCurrentState = () => {
        post({
            url: window.location.pathname,
            form_state_json: JSON.parse(
                localStorage.getItem('__STATE_MACHINE__')
            ),
        });
    };

    return {
        post,
        sendCurrentState,
        submitting,
        result,
        error,
    };
};

export default usePostBin;
